module.exports = __webpack_public_path__ + "img/news.5aa502d7.svg";